import type { SVGProps } from "react";

export default function ChevronLeft(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.49951 12.8327L1.49951 6.99935L6.49951 1.16602"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
